module.exports = __webpack_public_path__ + "static/media/US.60162bd6.svg";